import React from 'react';
import { Award, MapPin, Users, BookOpen } from 'lucide-react';
// Updated with 2025 statistics and latest information
export function About() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-669" data-mp="2oamfom32nkv1">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-670" data-mp="29kybnd3ia83m">
        {/* Page Header */}
        <div className="mb-12 text-center" data-id="element-671" data-mp="2ejrpj6mpg14b">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-672" data-mp="2egdnjzhydtxe">
            About Desert Sage Seminars
          </h1>
        </div>

        {/* Hero Section with Photo */}
        <div className="mb-16" data-id="element-673" data-mp="376vpuyaurr9r">
          <div className="bg-gradient-to-br from-brand-purple-50 to-white rounded-2xl overflow-hidden shadow-lg" data-id="element-674" data-mp="3751b61q6cve4">
            <div className="grid md:grid-cols-2 gap-8 items-center p-8" data-id="element-675" data-mp="2x8y2se4qc0iq">
              <div data-id="element-676" data-mp="2xbapf4lfmz24">
                <img src="https://cdn.magicpatterns.com/uploads/3rrVqztecsSvDZ8Krg5Ymg/Fixed_Jon_and_Dana-0136.jpg" alt="Jon and Dana Kichen" className="rounded-lg shadow-md w-full" data-id="element-677" data-mp="1gv7v6xeeiu4c" />
              </div>
              <div data-id="element-678" data-mp="1ujw7phv4tmak">
                <h2 className="text-3xl font-bold text-brand-purple-900 mb-4" data-id="element-679" data-mp="1pip13m4q6t5h">
                  Jon and Dana Kichen
                </h2>
                <p className="text-xl text-gray-700 font-medium mb-6" data-id="element-680" data-mp="23jj75y4awi0z">
                  OUR STORY
                </p>
                <div className="bg-brand-orange-50 border-l-4 border-brand-orange-500 p-4 rounded" data-id="element-681" data-mp="1yhtygp4jwgg2">
                  <p className="text-lg font-semibold text-gray-900" data-id="element-682" data-mp="2df30ccrhd2m1">
                    In 2025 Desert Sage Seminars helped Arizona real estate
                    licensees complete 84,708 CE classes On-Demand, In-Person
                    and Zoom!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mailing Address */}
        <div className="mb-12 flex items-center justify-center text-gray-700" data-id="element-683" data-mp="2w7nfysi65b7w">
          <MapPin className="w-5 h-5 mr-2 text-brand-purple-600" data-id="element-684" data-mp="2r93s2mk0lpcw" />
          <p className="text-base" data-id="element-685" data-mp="1ouwi1oyzw5uz">
            <strong data-id="element-686" data-mp="1ovxunxvnt0et">Desert Sage Seminars Mailing Address:</strong> 15029 N.
            Thompson Peak B111-487, Scottsdale, AZ 85260
          </p>
        </div>

        {/* Emeritus Award Highlight */}
        <div className="mb-12 bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-687" data-mp="1xuj8xgu3lt9s">
          <div className="flex items-start" data-id="element-688" data-mp="22n2y7b25ecuf">
            <Award className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-689" data-mp="22o47b9zlsp9i" />
            <p className="text-base text-gray-800" data-id="element-690" data-mp="27kupc2uyxuxk">
              In early 2021, Jon was awarded the{' '}
              <strong data-id="element-691" data-mp="2cie6baj1wlt7">REALTOR Emeritus designation</strong> from the National
              Association of REALTORS.
            </p>
          </div>
        </div>

        {/* About Jon Section */}
        <div className="mb-16" data-id="element-692" data-mp="2lk44cz7fuizy">
          <div className="bg-brand-purple-50 rounded-lg p-8 mb-8" data-id="element-693" data-mp="m7t2xinu3t48">
            <h2 className="text-3xl font-bold text-brand-purple-900 mb-6" data-id="element-694" data-mp="m9m78raz6192">
              About Jon
            </h2>

            <div className="space-y-6 text-base leading-relaxed text-gray-700" data-id="element-695" data-mp="r8pdug6lsfj5">
              <p data-id="element-696" data-mp="joo9necbqn4v">
                Jon obtained his real estate license in 1980 and owned and
                operated Kichen and Associates alongside his parents, Shirley
                and Rubin Kichen. The family business focused primarily on
                condominium conversion sales and residential resales.
              </p>

              <p data-id="element-697" data-mp="12lz84wq4tcj9">
                During the 1980s, Jon was highly active in SAAR (Scottsdale Area
                Association of REALTORS®) and was honored as Realtor® of the
                Year in 1984. He served on several SAAR committees, including
                Government Affairs and the Realtors Political Action Committee
                (RAPAC), throughout the decade.
              </p>

              <p data-id="element-698" data-mp="3de0qofdkziro">
                In 1986, Jon moved to Merrill Lynch Realty, where he became
                Sales Manager while continuing to sell real estate. When Merrill
                Lynch Realty transitioned to Prudential Realty, Jon played a key
                role in helping the company successfully adopt the
                well-respected national franchise.
              </p>

              <p data-id="element-699" data-mp="r5t3wlkrok80">
                In 1990, Jon joined Coldwell Banker and was appointed Branch
                Manager of the Camelback Branch. Within one year, he transformed
                an office that was losing money into one of the most profitable
                offices in the Western Region of Coldwell Banker—a distinction
                it maintained for many years. Jon was instrumental in moving
                Coldwell Banker Success Realty to the forefront of leadership in
                the Phoenix real estate community. He remained with Coldwell
                Banker Success Realty until spring 2002.
              </p>

              <p data-id="element-700" data-mp="3vj868tmdjk44">
                In June 2002, Jon joined the brokerage team at West USA Realty.
                While he played an active role on the brokerage team, Jon
                decided to pursue a different path in the real estate business.
                In 2006, inspiration struck to create a real estate school that
                would provide quality education to licensees. Desert Sage
                Seminars became an approved school in February 2006.
              </p>

              <p data-id="element-701" data-mp="x3vk9g8514n">
                In fall 2013, Jon parted ways with West USA Realty. Once word
                spread throughout the industry that Jon was available, he was
                pursued by numerous companies. Jon chose to focus on Desert Sage
                Seminars while accepting the position of Designated Broker for
                DeLex Realty, a new brokerage that needed guidance. Jon
                established essential systems and helped grow the company. In
                summer 2015, he decided to focus solely on education and
                resigned his position as Designated Broker of DeLex Realty.
                Today, he remains dedicated to teaching continuing education
                classes.
              </p>

              <div className="bg-white rounded-lg p-6 border-l-4 border-brand-orange-500 my-8" data-id="element-702" data-mp="3fbqwu6kgtw48">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-703" data-mp="3k2h2zm0pu2zz">
                  The Turning Point
                </h3>
                <p className="mb-4" data-id="element-704" data-mp="3p1tpg5nod821">
                  In July 2006, Jon had a near-death experience when a medical
                  procedure went horribly wrong. His condition deteriorated so
                  severely that it required a "code blue"—meaning the patient
                  has no heart rate and is turning blue. Through considerable
                  luck and the exceptional skill of the surgeon on the cardiac
                  crash team, he survived both the procedure and the resulting
                  emergency surgery.
                </p>
                <p className="mb-4" data-id="element-705" data-mp="go4pb88fio25">
                  During the six weeks he spent recovering at home, there was
                  plenty of time to reflect. First, he recognized that every day
                  is a gift. But he also realized that had he not survived, what
                  legacy would he have left for his family? Sure, he had life
                  insurance, retirement assets, and other savings, but what
                  viable source of income would continue after his paychecks
                  stopped? At that point, nothing.
                </p>
                <p className="mb-4" data-id="element-706" data-mp="1ndpeoa85m4w6">
                  Jon began pondering what he could do—what type of company he
                  could build that would continue generating income even after
                  he was gone. Since he was already a real estate trainer
                  instructing in-person classes and knew that the Arizona
                  Department of Real Estate permitted on-demand classes, that
                  seemed like a natural direction. In August 2006, the idea for
                  the Desert Sage Seminars website was born.
                </p>
                <p className="mb-4" data-id="element-707" data-mp="2boc8ctekdpnr">
                  For the remainder of 2006, he conducted feasibility studies to
                  determine if there was room for another company in the market.
                  The answer was yes. He began taking on-demand classes to
                  review the competition and spoke with real estate agents
                  throughout the state. Through this research, he identified
                  what was missing and what was needed in a new website. By
                  early 2007, he had developed a business plan and researched
                  the cost of building the website.
                </p>
                <p className="mb-4" data-id="element-708" data-mp="1nxybmpl1b2mu">
                  That process took about five months. In June 2007, he
                  contracted with a company to build the website and began
                  writing courses. By the end of 2007, he submitted his first
                  six classes to the Arizona Department of Real Estate. The
                  classes were approved by February, and on February 21, 2008,
                  the Desert Sage Seminars website officially launched.
                </p>
                <p className="mb-4" data-id="element-709" data-mp="1gf8o2o5auch3">
                  Thanks to pent-up demand from agents Jon had already spoken
                  with, Desert Sage Seminars had customers on day one—and that
                  success continues today. Desert Sage Seminars has earned an
                  excellent reputation as an industry leader, offering quality
                  education, the most user-friendly website, and unparalleled
                  customer service.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-710" data-mp="1ue8b5rd5yjb5">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-711" data-mp="4za800bpeq6d">Jon is</h3>
                <ul className="space-y-2 list-disc list-inside" data-id="element-712" data-mp="51d6z9uu3tn8">
                  <li data-id="element-713" data-mp="1qr0snmfzaq">A Certified GRI Instructor</li>
                  <li data-id="element-714" data-mp="3cdra0978x535">
                    A Certified AAR Ethics Instructor for National Association
                    of Realtors (NAR)
                  </li>
                  <li data-id="element-715" data-mp="37dlcwdi7iqdo">
                    A REALTOR Emeritus, awarded by the National Association of
                    REALTORS, after 40 years of service, and at least one year
                    on a NAR Committee
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-716" data-mp="3v3z6w9kcqzaw">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-717" data-mp="3r3ygrrnw4zo0">
                  Previously, Jon
                </h3>
                <ul className="space-y-2 list-disc list-inside" data-id="element-718" data-mp="3mam32ckr2da1">
                  <li data-id="element-719" data-mp="3hdvpbvwf3trs">Chaired the AAR Solar Addendum Workgroup, 2021</li>
                  <li data-id="element-720" data-mp="in3rjf00ndse">
                    Served on the AAR Risk Management Data/Cybersecurity Task
                    Force, 2018
                  </li>
                  <li data-id="element-721" data-mp="dusrmc59zrzu">
                    Served on the ADRE Education Advisory Committee, 2010 - 2020
                  </li>
                  <li data-id="element-722" data-mp="l9uywg4kts8t">
                    Served on AAR Purchase Contract Sub-Group, 2016, which
                    revised the current Residential Purchase Contract.
                  </li>
                  <li data-id="element-723" data-mp="v7slkz6sfgzb">Served on AAR HOA Addendum Task Force Committee, 2014</li>
                  <li data-id="element-724" data-mp="z8uivah59iyn">
                    Served on AAR Risk Management Committee, 2014-2018, 2019 -
                    2023
                  </li>
                  <li data-id="element-725" data-mp="1957be50ydqrt">Served on AAR Fair Housing Advisory Workgroup, 2021</li>
                  <li data-id="element-726" data-mp="1934h38srpbha">Served on AAR Purchase Contract Task Force, 2014</li>
                </ul>
              </div>

              <p className="font-medium text-gray-900" data-id="element-727" data-mp="1iv0nr88x69x4">
                Jon has owned, operated, educated, managed and practiced real
                estate his entire career. Volunteering on the local, state and
                national committee over his career has made Jon an advocate for
                the entire real estate industry.
              </p>
            </div>
          </div>
        </div>

        {/* About Dana Section */}
        <div className="mb-16" data-id="element-728" data-mp="3jyt2ayh50mw3">
          <div className="bg-gray-50 rounded-lg p-8" data-id="element-729" data-mp="3jvosnlkwkyy1">
            <h2 className="text-3xl font-bold text-brand-purple-900 mb-6" data-id="element-730" data-mp="1kk5lbpbhmkb">
              About Dana
            </h2>

            <div className="space-y-6 text-base leading-relaxed text-gray-700" data-id="element-731" data-mp="3swn0yg2djsmf">
              <p data-id="element-732" data-mp="bgnagpbjzzay">
                Before moving to Arizona in 1980, Dana was a Quality Control
                Analyst, Color Specialist and Customer Service Advisor for
                Helena Rubinstein cosmetics. Using her expertise, she began
                working for Revlon Cosmetics (Southwest Division) as the Color
                Analyst for all first production color products. Thereafter,
                Dana had her own Private Label Cosmetics business and sold
                products to beauty salons in the Phoenix Metro area.
              </p>

              <p data-id="element-733" data-mp="wsvx0dwddg4e">
                Subsequently, Dana became the Southwest Regional Training
                Coordinator for Estee Lauder Cosmetics and worked with the major
                retail stores training the staff for customer service, products,
                artistry and sales for 10 years. With her team, they created a
                training course that was adopted and used nationally by the
                company.
              </p>

              <p data-id="element-734" data-mp="e0jmv4zh5ajp">
                Dana joined The Dial Corporation (Henkel) where she handled
                escalated consumer issues and legal claims and helped manage the
                16-telephone call-center agents in the Consumer Information
                Center. She collaborated with Risk Management, Marketing, Sales
                and R&D for product issues and information and was part of the
                team to train her division on product and customer service
                skills for over 12 years.
              </p>

              <p className="font-medium text-gray-900" data-id="element-735" data-mp="1eq4vx3i294lc">
                Applying her training skills, product development insights, and
                creative customer service, Dana is currently the President of
                Marketing and Director of Customer Service for Desert Sage
                Seminars. Dana believes that quality informative
                Arizona-specific classes, a user-friendly website and
                exceptional customer service is an integral part of what
                distinguishes Desert Sage Seminars from their competition.
              </p>

              <p data-id="element-736" data-mp="m1r0mvicwmdh">
                Dana was selected and participated in the Scottsdale Area
                Association of Realtors® Leadership Academy-Class XVIII. Dana
                has been an active member and Strategic Partner in Women's
                Council of Realtors® since 2008. She served on the board as the
                Education Chair for Women's Council of Realtors®-Phoenix in
                2016 and 2017 and served as the Arizona State Women's Council of
                Realtors® 2016 State Education Chair (Arizona)
              </p>

              <p data-id="element-737" data-mp="2np3lnwqyom0z">
                Dana was awarded Affiliate of the Year for the Scottsdale
                Women's Council of REALTORS Network in 2011.
              </p>

              <p data-id="element-738" data-mp="2xo1kbsi3pvxp">
                Dana truly enjoys networking in the Realtor® community. She
                manages the Facebook group ARIZONA RE CE Classes that has over
                1,900 members. Her goal is to be sure that agents have access to
                any CE classes that are being held in the Valley.
              </p>

              <p data-id="element-739" data-mp="29xfbw046q9n6">
                Dana is a member of NAMPW and serves on the Membership
                Committee.
              </p>
            </div>
          </div>
        </div>

        {/* Personal Life Section */}
        <div className="bg-brand-purple-50 rounded-lg p-8" data-id="element-740" data-mp="1m9xqqnffe9t6">
          <h2 className="text-2xl font-bold text-brand-purple-900 mb-6" data-id="element-741" data-mp="1m8cwkyx0wsvu">
            Beyond Real Estate
          </h2>
          <div className="space-y-4 text-base leading-relaxed text-gray-700" data-id="element-742" data-mp="1e755mysf24ds">
            <p data-id="element-743" data-mp="1a74t5jovo39d">
              Jon is an avid photographer of nature, animals and extreme
              locations. Jon and Dana have trekked on a glacier, explored an
              active volcano, and hiked through a rainforest. Jon has also
              visited and photographed the Mayan Ruins in Chichen Itza, Mexico.
            </p>
            <p data-id="element-744" data-mp="r8s8p1sin6yh">
              Dana has travelled to England and France, especially enjoying
              visiting Monet's home at Giverney. She participated in a mission
              to Cuba and visited Alaska to see the Northern Lights.
            </p>
            <p data-id="element-745" data-mp="107vre4nrtkcg">
              Jon and Dana live in Scottsdale. Their son, Jason, is married to
              Stefeny and they have a teenager who is the light of all our
              lives.
            </p>
          </div>
        </div>
      </div>
    </div>;
}